import React from 'react';

import { RHFSelect } from '@/Components/shadcn/rhf-select';
import UIStrings from '@/Utils/UIStrings';
import directReportsOptions from './DirectReportsOptions';
import { JobDetailsFieldTypes } from '../JobDetailsStepUtils';

function DirectReports(): React.JSX.Element {
    const options = directReportsOptions.map((o) => ({ id: String(o.id), name: o.name }));

    return (
        <RHFSelect
            label={`${UIStrings.DirectReports}*`}
            name={JobDetailsFieldTypes.DirectReports}
            options={options}
            fieldDataCy={JobDetailsFieldTypes.DirectReports}
        />
    );
}

export default DirectReports;
